export function formatLocalized(number: number, forcedDecimalPlaces?: number): string {
	const options: Intl.NumberFormatOptions = { useGrouping: true }
	if (forcedDecimalPlaces !== undefined) {
		options.minimumFractionDigits = forcedDecimalPlaces
		options.maximumFractionDigits = forcedDecimalPlaces
	}
	return number.toLocaleString('de-DE', options)
}

export function appendUnit(formatted: string, unit: string): string {
	return unit ? formatted.replace(/([0-9,.]+)$/g, '$1 ' + unit) : formatted
}

/**
 * HTML `type="number"` uses `min` as the step base, so off-grid values
 * (e.g. 30 with min=1 step=10) ArrowUp to 31. Own the step: ±step from current, clamped.
 */
export function addClampedStep(
	current: number,
	direction: 1 | -1,
	step: number,
	min?: number,
	max?: number
): number {
	const next = current + direction * step
	const lower = min ?? Number.NEGATIVE_INFINITY
	const upper = max ?? Number.POSITIVE_INFINITY
	return Math.min(upper, Math.max(lower, next))
}

export type NumberStep = number | ((current: number, direction: 1 | -1) => number)

/** ArrowUp/Down for number inputs with an explicit step. Returns true when handled. */
export function onNumberStepKeydown(
	event: KeyboardEvent,
	options: {
		value: number | string | null | undefined
		step: NumberStep | undefined
		min?: number
		max?: number
		setValue: (next: number) => void
	}
): boolean {
	const { step, min, max, setValue } = options
	if (step == null) return false
	if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false

	event.preventDefault()
	const current = Number(options.value) || 0
	const direction = event.key === 'ArrowUp' ? 1 : -1
	const resolvedStep = typeof step === 'function' ? step(current, direction) : step
	setValue(addClampedStep(current, direction, resolvedStep, min, max))
	return true
}
